import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Header from "../components/Header";
import Footer from "../components/Footer";
import About from "../pages/About";
import ForHim from "../pages/ForHim";
import ForHer from "../pages/ForHer";
import Contact from "../pages/Contact";
import Services from "../pages/Services";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsAndConditions from "../pages/TermsAndConditions";
import Blogs from "../pages/Blogs";
import Shop from "../pages/Shop";


const Router = () => {

    const [headerData, setHeaderData] = useState([]);

    return (
        <BrowserRouter>

            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/for-him" element={<ForHim />} />
                <Route path="/for-her" element={<ForHer />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/contact" element={<Contact />} />
                {/* <Route path="/services" element={<Services />} /> */}
                {/* <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsAndConditions />} />
                <Route path="/blogs" element={<Blogs />} /> */}
                <Route path="*" element={<Home />} />

            </Routes>
            <Footer headerData={headerData} />
        </BrowserRouter >


    )
}
export default Router;